<script setup lang="ts">
import  Dialog from 'primevue/dialog';
import { ButtonType, CustomButton } from '@/components';
import { useStudySettingsStore } from '@/stores/studySettings';

defineProps({
  visible: {
    type: Boolean,
    required: true
  }
});

const studySettingsStore = useStudySettingsStore();

const archiveStudyChange = async () => {
  closeDialog();
  studySettingsStore.archive = (studySettingsStore.archive === 'Archive') ? 'Active' : 'Archive';
  await studySettingsStore.patchDetails({
    status: studySettingsStore.archive
  }, studySettingsStore.loaders.archiveStudy);

};
const emits = defineEmits(['onClose']);

const closeDialog = () => {
  emits('onClose');
};

</script>

<template>
    <Dialog :visible="visible"
        modal
        header="Archive Study?"
        class="dialog"
        style="width: 400px;"
        :closeOnEscape="true"
        :draggable="false"
        @update:visible="closeDialog">
        <div class="archive-description">After archiving the study you won't be able to collect data for it, invite users, or export data.</div>
        <div class="archive-description">You may unarchive at any moment in the future.</div>
          <CustomButton text="Confirm"
            :type="ButtonType.POSITIVE"
            @onClick="archiveStudyChange"/>
          <CustomButton text="Cancel"
            @onClick="closeDialog"/>
    </Dialog>
</template>

<style scoped lang="scss">
.archive-description {
  font-size: 14px;
  text-align: center;
  margin-bottom: 10px;
}
:deep(button) {
  width: 100%;
  margin-top: 10px;
}
</style>
